import * as tslib_1 from "tslib";
import strings from 'owa-strings/owa-mail-strings';
import trySaveMessage from './trySaveMessage';
import { action } from 'satcheljs/lib/legacy';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { findComposePlugins } from '../plugins/ComposePlugins';
export default action('switchBodyType')(function switchBodyType(viewState) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var contentOperationPlugin, isPlainText, isEmpty, resolveImmediately;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contentOperationPlugin = findComposePlugins(viewState).contentOperationPlugin;
                    isPlainText = viewState.bodyType == 'Text';
                    if (!(!isPlainText && hasCloudyAttachment(viewState))) return [3 /*break*/, 2];
                    return [4 /*yield*/, confirm(null /*title*/, strings.switchToPlainTextCloudAttachmentWarning, false /*resolveImmediately*/, {
                            hideCancelButton: true,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    isEmpty = contentOperationPlugin.isEmpty();
                    resolveImmediately = isPlainText || isEmpty;
                    return [4 /*yield*/, confirm(null, strings.switchToPlainTextWarning, resolveImmediately)];
                case 3:
                    if ((_a.sent()) ==
                        DialogResponse.ok) {
                        if (viewState.bodyType == 'HTML') {
                            convertHtmlToText(viewState, contentOperationPlugin);
                        }
                        else {
                            convertTextToHtml(viewState);
                        }
                    }
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
});
function convertHtmlToText(viewState, plugin) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (plugin) {
                // Remove inline images and save
                plugin.removeInlineImage();
                plugin.updateContentToViewState();
                plugin.stopSaveOnDispose();
                trySaveMessage(viewState, true /*isAutoSave*/);
                viewState.content = plugin.getTextContent();
                viewState.bodyType = 'Text';
                viewState.isRibbonShown = false;
                viewState.docking.isTopDocking = false;
                viewState.docking.isBottomDocking = false;
                viewState.isDirty = true;
            }
            return [2 /*return*/];
        });
    });
}
function convertTextToHtml(viewState) {
    viewState.bodyType = 'HTML';
    var content = viewState.content;
    content = content.replace(/&/g, '&amp;');
    content = content.replace(/</g, '&lt;');
    content = content.replace(/>/g, '&gt;');
    content = content.replace(/'/g, '&#39;');
    content = content.replace(/"/g, '&quot;');
    content = content.replace(/^ /gm, '&nbsp;');
    content = content.replace(/(\n|\r\n)/g, '<br></div><div>');
    content = content.replace(/\s\s/g, ' &nbsp;');
    content = "<div>" + content + "<br></div>";
    viewState.content = content;
    viewState.isRibbonShown = true;
    viewState.isDirty = true;
}
function hasCloudyAttachment(viewState) {
    if (!viewState.attachmentWell ||
        !viewState.attachmentWell.docViewAttachments ||
        viewState.attachmentWell.docViewAttachments.length == 0) {
        return false;
    }
    for (var _i = 0, _a = viewState.attachmentWell.docViewAttachments; _i < _a.length; _i++) {
        var attachment = _a[_i];
        if (attachment.isCloudy) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=switchBodytype.js.map